import React from 'react';
import {Button, Col, DropdownButton, Dropdown, Form} from "react-bootstrap";
import {AsyncTypeahead} from "react-bootstrap-typeahead";
import {GlobalContext} from "../../GlobalContext";

export class MarketingSearch extends React.Component {
    static contextType = GlobalContext;
    ref = React.createRef();

    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            options: [],
            inputValue: ''
        };
    }

    doSearch = (query) => {
        this.context.apiRequest("GET", "/marketing/search?q="+encodeURIComponent(query))
            .then(d => {
                if(d.data) this.setState({options: d.data});
                this.setState({loading: false});
            })
    }

    selected = (selectionArray) => {
        if(selectionArray && selectionArray.length > 0) {
            if(this.props.clearOnSelect) {
                this.ref.current.clear();
            }
            if(this.props.itemSelected) {
                this.props.itemSelected(selectionArray[0].discrim, Number(selectionArray[0].id));
            }
        }
    };

    goClicked = () => {
        if (this.props.goButtonClicked) {
            this.props.goButtonClicked(this.state.inputValue);
        }
    };

    newGroupClicked = () => {
        this.props.itemSelected('Group', 0);
    }

    newProviderClicked = () => {
        this.props.itemSelected('Provider', 0);
    }

    inputChanged = (val) => {
        this.setState({inputValue: val});
    }

    render() {
        return (
            <Form className={"mb-3"}>
                <Form.Row>
                    <Col md={8}>
                        <AsyncTypeahead id={this.props.id} size={this.props.size}
                                        labelKey={'label'}
                                        isLoading={this.state.loading}
                                        onSearch={this.doSearch}
                                        options={this.state.options}
                                        onChange={this.selected}
                                        onInputChange={this.inputChanged}
                                        defaultInputValue={''}
                                        placeholder={'Group/Provider Name'}
                                        ref={this.ref}
                                        align={"left"}/>
                    </Col>
                    <Col md={4}>
                        {
                            this.props.showGoButton ? <Button className={"mr-2"} variant={"dark"} onClick={this.goClicked} disabled={!this.state.inputValue}>Go</Button> : <span/>
                        }
                        {
                            this.props.showNewButtons ? <DropdownButton id="marketingNewDropdown" title="New" variant={"dark"} className={"d-inline-block"}>
                                <Dropdown.Item onClick={this.newProviderClicked}>Provider</Dropdown.Item>
                                <Dropdown.Item onClick={this.newGroupClicked}>Group</Dropdown.Item>
                            </DropdownButton> : <span/>
                        }
                    </Col>
                </Form.Row>
            </Form>
        );
    }
}